import React from 'react'
import { useTranslation } from 'react-i18next'

import { Heading6 } from '@ui/Typography'
import { Button } from '@ui/components/Button'
import { CheckIcon } from '@ui/icons/Check.icon'

import styles from './Statement.module.scss'

interface StatementProps {
  goBack: () => void
}

export const DownloadedStatement: React.FC<StatementProps> = ({ goBack }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.statement}>
      <div className={styles.reportIconWrapper}>
        <CheckIcon size={64} color='text-success-high-em' />
      </div>
      <Heading6 className={styles.title} medium>
        {t('Statements.Statement successfully downloaded')}
      </Heading6>
      <Button.Primary size='lg' onClick={goBack}>
        {t('Statements.Download another statement')}
      </Button.Primary>
    </div>
  )
}
